/**
 * Isolated storefront stand-in for Shopify carts/* webhooks.
 * Disable: set window.allureCartEventSync.enabled = false, or the Liquid flag.
 * Full revert: remove `{% render 'al-cart-event-sync' %}` from layout/theme.liquid
 * and delete this file plus snippets/al-cart-event-sync.liquid.
 */
(function () {
  var config = window.allureCartEventSync;
  if (!config || config.enabled === false) return;
  if (window.__allureCartEventSyncBound) return;
  window.__allureCartEventSyncBound = true;

  var ENDPOINT = config.endpoint;
  var SHOP_DOMAIN = config.shopDomain || '';
  var CUSTOMER_ID = config.customerId == null ? null : String(config.customerId);
  var DEBOUNCE_MS = 450;
  var SYNC_QUERY = 'allure_customer_id=1';
  var STORAGE_CUSTOMER = 'allure_cart_event_customer_id';
  var STORAGE_FP = 'allure_cart_event_fp';
  var STORAGE_COUNT = 'allure_cart_event_count';
  var STORAGE_CREATED = 'allure_cart_event_created';

  var REASON_PRIORITY = {
    update: 1,
    create: 2,
    login: 3,
    logout: 4,
  };

  var pendingReason = null;
  var debounceTimer = null;
  var inFlight = false;
  var queuedReason = null;
  var lastItemCount = null;
  var lastFingerprint = '';
  var createdAtByToken = readCreatedAtMap();
  var logoutHref = null;
  var baselineReady = null;
  var cartCache = { data: null, at: 0 };
  var lastCartSnapshot = null;
  var cartJsInFlight = null;
  var CART_CACHE_MS = 200;
  var originalFetch = window.fetch.bind(window);

  function reasonRank(reason) {
    return REASON_PRIORITY[reason] || 0;
  }

  function keepHighestReason(current, next) {
    if (!current) return next;
    if (!next) return current;
    return reasonRank(next) > reasonRank(current) ? next : current;
  }

  function readCreatedAtMap() {
    try {
      var raw = sessionStorage.getItem(STORAGE_CREATED);
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  }

  function writeCreatedAtMap() {
    try {
      sessionStorage.setItem(STORAGE_CREATED, JSON.stringify(createdAtByToken));
    } catch (error) {
      /* ignore quota / private mode */
    }
  }

  function rememberCreatedAt(token) {
    if (!token) return null;
    if (!createdAtByToken[token]) {
      createdAtByToken[token] = new Date().toISOString();
      writeCreatedAtMap();
    }
    return createdAtByToken[token];
  }

  function centsToMoney(cents) {
    var value = Number(cents);
    if (!Number.isFinite(value)) return '0.00';
    return (value / 100).toFixed(2);
  }

  function moneySet(amount, currency) {
    return {
      shop_money: { amount: amount, currency_code: currency },
      presentment_money: { amount: amount, currency_code: currency },
    };
  }

  function mapLineItem(item, currency) {
    var price = centsToMoney(item.price);
    var linePrice = centsToMoney(item.line_price);
    var originalPrice = centsToMoney(
      item.original_price == null ? item.price : item.original_price,
    );
    var originalLinePrice = centsToMoney(
      item.original_line_price == null ? item.line_price : item.original_line_price,
    );
    var discountedPrice = centsToMoney(
      item.discounted_price == null ? item.price : item.discounted_price,
    );
    var totalDiscount = centsToMoney(item.total_discount == null ? 0 : item.total_discount);
    var properties = propertiesForBackend(item.properties);

    return {
      id: item.id,
      properties: properties,
      quantity: item.quantity,
      variant_id: item.variant_id || item.id,
      key: item.key,
      discounted_price: discountedPrice,
      discounts: Array.isArray(item.discounts) ? item.discounts : [],
      gift_card: Boolean(item.gift_card),
      grams: item.grams == null ? 0 : item.grams,
      line_price: linePrice,
      original_line_price: originalLinePrice,
      original_price: originalPrice,
      price: price,
      product_id: item.product_id,
      sku: item.sku || null,
      taxable: item.taxable !== false,
      title: item.title,
      total_discount: totalDiscount,
      vendor: item.vendor || null,
      discounted_price_set: moneySet(discountedPrice, currency),
      line_price_set: moneySet(linePrice, currency),
      original_line_price_set: moneySet(originalLinePrice, currency),
      price_set: moneySet(price, currency),
      total_discount_set: moneySet(totalDiscount, currency),
      parent_relationship: item.parent_relationship || null,
    };
  }

  function propertiesForBackend(properties) {
    if (!properties || typeof properties !== 'object') return null;
    var cleaned = {};
    Object.keys(properties).forEach(function (key) {
      if (key === '_customer_id') return;
      cleaned[key] = properties[key];
    });
    return Object.keys(cleaned).length > 0 ? cleaned : null;
  }

  function mapCartToWebhook(cart) {
    var currency = cart.currency || 'USD';
    var token = cart.token || '';
    var items = Array.isArray(cart.items) ? cart.items : [];
    return {
      id: token,
      token: token,
      customerId: CUSTOMER_ID,
      line_items: items.map(function (item) {
        return mapLineItem(item, currency);
      }),
      note: cart.note || null,
      updated_at: new Date().toISOString(),
      created_at: rememberCreatedAt(token),
    };
  }

  function fingerprint(cart, customerId) {
    var lines = (cart.items || [])
      .map(function (item) {
        return [item.key, item.quantity, JSON.stringify(item.properties || {})].join(':');
      })
      .join('|');
    return [cart.token || '', customerId || '', cart.item_count, lines].join('::');
  }

  function persistSession(cart, fp) {
    lastFingerprint = fp;
    lastItemCount = cart.item_count;
    try {
      sessionStorage.setItem(STORAGE_FP, fp);
      sessionStorage.setItem(STORAGE_COUNT, String(cart.item_count));
      if (CUSTOMER_ID) {
        sessionStorage.setItem(STORAGE_CUSTOMER, CUSTOMER_ID);
      } else {
        sessionStorage.removeItem(STORAGE_CUSTOMER);
      }
    } catch (error) {
      /* ignore */
    }
  }

  function isFullCart(data) {
    return Boolean(
      data &&
        Array.isArray(data.items) &&
        typeof data.token === 'string' &&
        typeof data.item_count === 'number',
    );
  }

  function setCartCache(data) {
    if (!isFullCart(data)) return;
    cartCache = { data: data, at: Date.now() };
    lastCartSnapshot = data;
  }

  function clearCartSnapshot() {
    lastCartSnapshot = null;
    cartCache = { data: null, at: 0 };
  }

  function isInternalCartUrl(url) {
    return url.indexOf(SYNC_QUERY) !== -1;
  }

  function sectionsToRefresh() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    var mainItems = document.getElementById('main-cart-items');
    var mainFooter = document.getElementById('main-cart-footer');
    if (mainItems && mainItems.dataset && mainItems.dataset.id) ids.push(mainItems.dataset.id);
    if (mainFooter && mainFooter.dataset && mainFooter.dataset.id) ids.push(mainFooter.dataset.id);
    return ids.filter(function (id, index, list) {
      return list.indexOf(id) === index;
    });
  }

  function paintDiscountedCart(cart) {
    var sections = cart && cart.sections;
    if (!sections) return;

    if (sections['cart-drawer']) {
      var drawerDoc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var sourceItems = drawerDoc.querySelector('cart-drawer-items');
      var targetItems = document.querySelector('cart-drawer-items');
      if (sourceItems && targetItems) targetItems.replaceWith(sourceItems);
      var sourceDrawerFooter = drawerDoc.querySelector('.cart-drawer__footer');
      var targetDrawerFooter = document.querySelector('#CartDrawer .cart-drawer__footer');
      if (sourceDrawerFooter && targetDrawerFooter) {
        targetDrawerFooter.innerHTML = sourceDrawerFooter.innerHTML;
      }
      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);
    }

    var mainItems = document.getElementById('main-cart-items');
    var mainItemsId = mainItems && mainItems.dataset ? mainItems.dataset.id : null;
    if (mainItems && mainItemsId && sections[mainItemsId]) {
      var itemsDoc = new DOMParser().parseFromString(sections[mainItemsId], 'text/html');
      var sourceContents = itemsDoc.querySelector('.js-contents');
      var targetContents = mainItems.querySelector('.js-contents');
      if (sourceContents && targetContents) targetContents.innerHTML = sourceContents.innerHTML;
      mainItems.classList.toggle('is-empty', cart.item_count === 0);
    }

    var mainFooter = document.getElementById('main-cart-footer');
    var mainFooterId = mainFooter && mainFooter.dataset ? mainFooter.dataset.id : null;
    if (mainFooter && mainFooterId && sections[mainFooterId]) {
      var footerDoc = new DOMParser().parseFromString(sections[mainFooterId], 'text/html');
      var sourceFooter = footerDoc.querySelector('#main-cart-footer');
      if (sourceFooter) {
        mainFooter.replaceWith(sourceFooter);
      } else {
        var sourceFooterContents = footerDoc.querySelector('.js-contents');
        var targetFooterContents = mainFooter.querySelector('.js-contents');
        if (sourceFooterContents && targetFooterContents) {
          targetFooterContents.innerHTML = sourceFooterContents.innerHTML;
        }
      }
      var footerEl = document.getElementById('main-cart-footer');
      if (footerEl) footerEl.classList.toggle('is-empty', cart.item_count === 0);
    }

    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var bubbleDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var sourceBubble = bubbleDoc.querySelector('.shopify-section') || bubbleDoc.body;
        var targetBubble = bubble.querySelector('.shopify-section') || bubble;
        if (sourceBubble) targetBubble.innerHTML = sourceBubble.innerHTML;
      }
    }

    if (window.cartPendingPricing && typeof window.cartPendingPricing.apply === 'function') {
      window.cartPendingPricing.apply();
    }
  }

  function cartDiscountAttribute(cart) {
    if (!cart || !cart.attributes) return '';
    return String(cart.attributes.discount || '') + '|' + String(cart.attributes.discount_applied || '');
  }

  function pricingSignature(cart) {
    if (!cart) return '';
    var items = cart.items || [];
    var lines = items
      .map(function (item) {
        return [
          item.key,
          item.quantity,
          item.final_line_price,
          item.line_price,
          item.total_discount,
          item.original_line_price,
        ].join(':');
      })
      .join('|');
    return [cart.item_count, cart.total_price, cart.total_discount, lines].join('::');
  }

  function cartHasVisibleDiscount(cart) {
    if (!cart) return false;
    if (Number(cart.total_discount) > 0) return true;
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      return true;
    }
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.discounts && item.discounts.length) return true;
      if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
        return true;
      }
      if (Number(item.total_discount) > 0) return true;
      if (
        item.final_line_price != null &&
        Number(item.original_line_price) !== Number(item.final_line_price)
      ) {
        return true;
      }
    }
    return false;
  }

  function fetchFreshCart() {
    return originalFetch('/cart.js?_=' + Date.now(), { cache: 'no-store' }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    }).then(function (cart) {
      lastCartSnapshot = cart;
      return cart;
    });
  }

  function waitForDiscountedCart(timeoutMs, intervalMs, baselineCart) {
    var start = Date.now();
    var baselineSig = pricingSignature(baselineCart);
    var baselineAttr = cartDiscountAttribute(baselineCart);
    var attrChangedAt = 0;
    function attempt() {
      return fetchFreshCart().then(function (cart) {
        var now = Date.now();
        if (cartDiscountAttribute(cart) !== baselineAttr && !attrChangedAt) {
          attrChangedAt = now;
        }
        if (pricingSignature(cart) !== baselineSig) return cart;
        if (attrChangedAt && now - attrChangedAt >= 800) return cart;
        if (cartHasVisibleDiscount(cart) && now - start >= 400) return cart;
        if (now - start >= timeoutMs) return cart;
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(attempt());
          }, intervalMs);
        });
      });
    }
    return attempt();
  }

  function fetchAndPaintSections(itemCount) {
    var ids = sectionsToRefresh();
    if (!ids.length) return Promise.resolve();
    var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    var params = new URLSearchParams({
      sections: ids.join(','),
      sections_url: window.location.pathname,
      _: String(Date.now()),
    });
    return originalFetch(cartUrl + '?' + params.toString(), { cache: 'no-store' }).then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh cart sections');
      return response.json();
    }).then(function (sections) {
      paintDiscountedCart({
        sections: sections,
        item_count: itemCount,
      });
    });
  }

  function refreshCartAfterDiscount(baselineCart) {
    cartCache = { data: null, at: 0 };
    return waitForDiscountedCart(8000, 400, baselineCart)
      .then(function (cart) {
        return fetchAndPaintSections(cart && cart.item_count);
      })
      .catch(function (error) {
        console.error('allure cart event sync:', error);
      });
  }

  function getCartCache(maxAge) {
    if (!cartCache.data) return null;
    if (Date.now() - cartCache.at > maxAge) return null;
    return cartCache.data;
  }

  function cartJsonResponse(data) {
    return new Response(JSON.stringify(data), {
      status: 200,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  function requestUrl(resource) {
    if (typeof resource === 'string') return resource;
    if (resource && resource.url) return String(resource.url);
    return '';
  }

  function requestMethod(resource, init) {
    if (init && init.method) return String(init.method).toUpperCase();
    if (resource && resource.method) return String(resource.method).toUpperCase();
    return 'GET';
  }

  function isCartJsUrl(url) {
    try {
      var path = new URL(url, window.location.origin).pathname;
      return path === '/cart.js' || path.slice(-8) === '/cart.js';
    } catch (error) {
      return url.indexOf('/cart.js') !== -1 && url.indexOf('sections=') === -1;
    }
  }

  function fetchCart() {
    if (isFullCart(lastCartSnapshot)) return Promise.resolve(lastCartSnapshot);
    var cached = getCartCache(CART_CACHE_MS);
    if (isFullCart(cached)) return Promise.resolve(cached);
    return originalFetch('/cart.js?_=' + Date.now(), {
      cache: 'no-store',
      credentials: 'same-origin',
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    }).then(function (cart) {
      setCartCache(cart);
      return cart;
    });
  }

  function resolveTopic(reason, cart) {
    if (reason === 'logout') return 'customers/logout';
    if (reason === 'login') return 'customers/login';
    if (reason === 'create' || (lastItemCount === 0 && cart.item_count > 0)) {
      return 'carts/create';
    }
    return 'carts/update';
  }

  function postWebhook(topic, body, keepalive) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Shopify-Topic': topic,
        'X-Shopify-Shop-Domain': SHOP_DOMAIN,
      },
      body: JSON.stringify(body),
      mode: 'cors',
      keepalive: Boolean(keepalive),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart event sync failed: ' + response.status);
      }
      return response.json().catch(function () {
        return null;
      });
    });
  }

  function flush(reason, keepalive) {
    var activeReason = reason || pendingReason || 'update';
    pendingReason = null;

    if (inFlight) {
      queuedReason = keepHighestReason(queuedReason, activeReason);
      return Promise.resolve();
    }

    inFlight = true;
    return fetchCart()
      .then(function (cart) {
        var fp = fingerprint(cart, CUSTOMER_ID);
        if (activeReason !== 'logout' && fp === lastFingerprint) {
          persistSession(cart, fp);
          return null;
        }

        var topic = resolveTopic(activeReason, cart);
        var body = mapCartToWebhook(cart);
        return postWebhook(topic, body, keepalive).then(function () {
          persistSession(cart, fp);
          if (activeReason === 'logout' || keepalive) return null;
          return refreshCartAfterDiscount(cart);
        });
      })
      .catch(function (error) {
        console.error('allure cart event sync:', error);
      })
      .then(function () {
        inFlight = false;
        if (queuedReason) {
          var next = queuedReason;
          queuedReason = null;
          return flush(next, keepalive);
        }
        if (logoutHref) {
          var href = logoutHref;
          logoutHref = null;
          window.location.href = href;
        }
      });
  }

  function scheduleSync(reason) {
    if (config.enabled === false) return;
    pendingReason = keepHighestReason(pendingReason, reason);
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      baselineReady.then(function () {
        flush(pendingReason || reason, false);
      });
    }, DEBOUNCE_MS);
  }

  function isCartMutationUrl(url) {
    return (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear') !== -1
    );
  }

  function wrapFetch() {
    window.fetch = function (resource, init) {
      var url = requestUrl(resource);
      var method = requestMethod(resource, init);

      if (method === 'GET' && isCartJsUrl(url)) {
        var cached = getCartCache(CART_CACHE_MS);
        if (cached) return Promise.resolve(cartJsonResponse(cached));
        if (cartJsInFlight) {
          return cartJsInFlight.then(function (data) {
            return cartJsonResponse(data);
          });
        }
        cartJsInFlight = originalFetch(resource, init)
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to load cart');
            return response.json();
          })
          .then(function (data) {
            setCartCache(data);
            return data;
          })
          .finally(function () {
            cartJsInFlight = null;
          });
        return cartJsInFlight.then(function (data) {
          return cartJsonResponse(data);
        });
      }

      return originalFetch(resource, init).then(function (response) {
        if (isCartMutationUrl(url) && response.ok) {
          if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/clear') !== -1) {
            clearCartSnapshot();
          } else {
            response
              .clone()
              .json()
              .then(function (data) {
                setCartCache(data);
              })
              .catch(function () {});
          }
          if (!isInternalCartUrl(url)) scheduleSync('update');
        }
        return response;
      });
    };
  }

  function subscribeCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (
        event &&
        (event.source === 'allure-customer-id' || event.source === 'allure-discount-attributes')
      ) {
        return;
      }
      scheduleSync('update');
    });
  }

  function detectLoginReason() {
    if (!CUSTOMER_ID) return null;
    var previous = null;
    try {
      previous = sessionStorage.getItem(STORAGE_CUSTOMER);
    } catch (error) {
      previous = null;
    }
    if (previous === CUSTOMER_ID) return null;
    return 'login';
  }

  function bindLogout() {
    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest && event.target.closest('a[href*="/account/logout"]');
        if (!link) return;
        event.preventDefault();
        if (debounceTimer) {
          clearTimeout(debounceTimer);
          debounceTimer = null;
        }
        logoutHref = link.href;
        try {
          sessionStorage.removeItem(STORAGE_CUSTOMER);
        } catch (error) {
          /* ignore */
        }
        baselineReady.then(function () {
          flush('logout', true);
        });
        setTimeout(function () {
          if (logoutHref) {
            var href = logoutHref;
            logoutHref = null;
            window.location.href = href;
          }
        }, 1200);
      },
      true,
    );
  }

  function seedBaseline() {
    var existing = lastCartSnapshot || getCartCache(CART_CACHE_MS);
    var shouldFetch = Boolean(pendingReason) && !existing;
    var ready = existing
      ? Promise.resolve(existing)
      : shouldFetch
        ? fetchCart()
        : Promise.resolve(null);

    return ready
      .then(function (cart) {
        var storedCount = null;
        var storedFp = null;
        try {
          storedCount = sessionStorage.getItem(STORAGE_COUNT);
          storedFp = sessionStorage.getItem(STORAGE_FP);
        } catch (error) {
          storedCount = null;
          storedFp = null;
        }

        if (!cart) {
          if (storedCount != null) lastItemCount = Number(storedCount);
          return;
        }

        rememberCreatedAt(cart.token);
        var fp = fingerprint(cart, CUSTOMER_ID);
        lastItemCount = storedCount != null ? Number(storedCount) : cart.item_count;

        if (!pendingReason) {
          if (storedFp && storedFp !== fp) {
            pendingReason = lastItemCount === 0 && cart.item_count > 0 ? 'create' : 'update';
            lastFingerprint = storedFp;
          } else {
            lastItemCount = cart.item_count;
            lastFingerprint = fp;
          }
        }
      })
      .catch(function (error) {
        console.error('allure cart event sync:', error);
      });
  }

  wrapFetch();
  pendingReason = detectLoginReason();
  baselineReady = seedBaseline().then(function () {
    if (pendingReason) scheduleSync(pendingReason);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      subscribeCartUpdates();
      bindLogout();
    });
  } else {
    subscribeCartUpdates();
    bindLogout();
  }
})();
